import isEmpty from 'lodash.isempty'
import { ListingStrategy } from '../../types/api'

// Prefer the most specific strategy, in terms of how many categories it has mapped.
// Less categories == more specific == a better default choice.
// Note, this is the opposite of how classic list (JoinedForm) works.
export function getPreferredStrategy(listingStrategies: ListingStrategy[]) {
  if (listingStrategies.length === 0) {
    // eslint-disable-next-line no-throw-literal
    throw 'calling code should check that listingStrategies.length > 0'
  }

  const preferredStrategy = listingStrategies
    .filter((s: ListingStrategy) => s.categories.length > 0)
    .sort((s1, s2) => s1.categories.length - s2.categories.length)[0]

  // listingStrategies[0] - You may only have strategies that are mapped to 0 categories, such as "General Strategy No Categories"
  return preferredStrategy || listingStrategies[0]
}

// feel free to expand this over time, like if you need to check objects
type AnythingButNumberOrBoolean = string | any[]

// lodash isEmpty, except the compiler prevents you from passing in numbers (a common footgun).
// Lodash maintainers think numbers and booleans are always empty 🙃 https://github.com/lodash/lodash/issues/496
// Calling code should call numberVar.toString() on numeric parameters.
// Calling code should handle boolean parameters in another way.
export function safeIsEmpty(v: AnythingButNumberOrBoolean) {
  return isEmpty(v)
}
